import React, { Component } from 'react';
import PropTypes from 'prop-types';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor, Dropdown } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState,  Modifier } from 'draft-js';
import Dialog from 'components/Dialog';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';


class GlobalParameter extends Component {
    static propTypes = {
      onChange: PropTypes.func,
      editorState: PropTypes.object,
    };
  
    insertParameter(parameter){
        const { editorState, onChange } = this.props;

        // Get block for current selection
        let selection = editorState.getSelection();
        const anchorKey = selection.getAnchorKey();
        const currentContent = editorState.getCurrentContent();
        const currentBlock = currentContent.getBlockForKey(anchorKey);

        //Then based on the docs for SelectionState -
        const start = selection.getStartOffset();
        const end = selection.getEndOffset();
        const selectedText = currentBlock.getText().slice(start, end);

        //this._insertDialog.show( editorState.getCurrentContent(),  editorState.getSelection());
        const entityKey = editorState
        .getCurrentContent()
        .createEntity('PLACEHOLDER', 'IMMUTABLE')
        .getLastCreatedEntityKey();

        let contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        selection,
        selectedText || parameter,
        editorState.getCurrentInlineStyle(),
        entityKey,
      );


     
      onChange(EditorState.push(editorState, contentState, 'insert-characters'));
    };
  
    render() {
      return (
        <div className="rdw-option-wrapper" onClick={this.insertParameter.bind(this, this.props.param)}>
        <i className="fa fa-bolt"></i>&nbsp;{this.props.param}
        </div>
        
      );
    }
  }

class RichField extends Component {
    constructor(props) {
        super(props);

        let { input, html, autoFocus, disabled, className, placeholder } = this.props;
        const contentBlock = htmlToDraft(html || input.value || "");
       
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.state = {
                editorState
            };
        }
    }

    onEditorStateChange(editorState){
        this.setState({
          editorState,
        });

        let html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        this.props.input.onChange(html);
      };

    render() {
        let {meta: {touched, error, warning}, style} = this.props;

        let customButtons = this.props.showParameters? [<GlobalParameter param={'{invoice_url}'} />,
        <GlobalParameter param={'{shop_name}'} />,
        <GlobalParameter param={'{invoice_number}'} />,
        <GlobalParameter param={'{customer_first_name}'} />,
        <GlobalParameter param={'{customer_last_name}'} />,
        ] :[];

        return <div><Editor toolbar={{
            options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history']
        }}  toolbarOnFocus toolbarCustomButtons={customButtons} editorStyle={style} editorState={this.state.editorState} onEditorStateChange={this.onEditorStateChange.bind(this)} />
            {touched &&
        ((error && <span className="label label-danger">{error}</span>) ||
        (warning && <span className="label label-warning">{warning}</span>))}
            </div>
    }
}

RichField.propTypes = {
    showParameters: PropTypes.bool
}
export default RichField;


// WEBPACK FOOTER //
// app/components/RichField.jsx